export const config = {
  reference: new Date().getTime().toString(),
  publicKey: process.env.REACT_APP_PAYSTACK_PUBLIC_KEY!,
};
